import React from 'react'
import injectSheet from 'react-jss'
import numeral from 'numeral'
import styles from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from 'helpers/globals'
import resizeDimensions from './resizeDimensions'

export const fileTypeInvalid = type =>
  !(type.includes('pdf') || type.includes('jpeg') || type.includes('png') || type.includes('bmp') || type.includes('jpg'))

export const prepProps = ({ size, type, width, height, showContactLink }) => {
  const sizeInMb = size / 1000000
  const resizeInfo = resizeDimensions({ width, height })
  return {
    size: sizeInMb,
    warnSize: sizeInMb > 5,
    warnType: fileTypeInvalid(type),
    warnDimension: width > 8000 || height > 8000,
    resizedWidth: width && resizeInfo.width,
    resizedHeight: height && resizeInfo.height,
    type,
    width,
    height,
    showContactLink
  }
}

const InfoDisplay = ({ classes, warning, description, value, showOkIcon, warnColor, warningFeedback }) =>
  <div>
    <div className={classes.infoText}><strong>{description}:</strong> {value} {showOkIcon && <FontAwesomeIcon icon='check-circle' color={COLORS.ok} />}</div>
    {
      warning &&
      <ul className={classes.list}>
        <li><FontAwesomeIcon icon='exclamation-circle' color={warnColor} /> {warningFeedback}</li>
      </ul>
    }
  </div>

class FileInfo extends React.Component {
  render = _ => {
    const { props: { size, type, warnSize, warnType, warnDimension,
      width, height, classes, resizedWidth, resizedHeight, showContactLink } } = this
    return (
      <div className={classes.container}>
        <InfoDisplay
          classes={classes}
          warning={warnSize && !warnType}
          description='File size'
          value={`${size.toFixed(2)}MB`}
          showOkIcon={!warnSize && !warnType}
          warnColor={COLORS.warning}
          warningFeedback='File is large, processing may not be possible. Consider resizing.'
        />
        <InfoDisplay
          classes={classes}
          warning={warnType}
          description='Type'
          value={type}
          showOkIcon={!warnType}
          warnColor={COLORS.danger}
          warningFeedback={`File type ${type} is not supported! Please upload a JPG, BMP, PNG, or PDF.`}
        />
        <InfoDisplay
          classes={classes}
          warning={warnDimension && !warnType}
          description='Dimensions'
          value={width !== null && height !== null ? `${numeral(width.toFixed()).format('0,0')}px x ${numeral(height.toFixed()).format('0,0')}px` : 'Calculating dimensions...'}
          showOkIcon={!warnDimension && width > 0 && height > 0}
          warnColor={COLORS.warning}
          warningFeedback={width && height && `Dimensions are large, processing may not be possible. Consider resizing to ${resizedWidth}px x ${resizedHeight}px`}
        />
        {
          (warnType || warnDimension || warnSize || showContactLink) &&
          <p>Need help? <a href={`${IPVM_URL}/contact?&message=Calculator Floorplan Upload&subject=Calculator Floorplan Upload`} target='_blank'>Contact us.</a></p>
        }
      </div>
    )
  }
}

export default injectSheet(styles)(FileInfo)



// WEBPACK FOOTER //
// ./src/components/FloorPlanUploader/FileInfo/index.js